export enum FLOOR_SORTING {
  FLOOR_LEVEL = 'floor_level',
  FLOOR_NAME = 'name',
}

export const floorSortingByNameMapper = new Map<string, FLOOR_SORTING>([
  ['floor_name', FLOOR_SORTING.FLOOR_NAME],
  ['floor_level', FLOOR_SORTING.FLOOR_LEVEL],
]);
